export async function getDecryptedValue(base64Data) {
  if (!base64Data) return undefined;

  const rawData = base64ToArrayBuffer(base64Data);
  const iv = rawData.slice(0, 16);
  const encryptedData = rawData.slice(16);

  const keyRaw = base64ToArrayBuffer(process.env.REACT_APP_LENDER_ENCRYPTION_KEY);
  const key = await crypto.subtle.importKey("raw", keyRaw.slice(0, 32), { name: "AES-CBC" }, false, ["decrypt"]);

  const decrypted = await crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv: iv,
    },
    key,
    encryptedData
  );

  const decoder = new TextDecoder();
  return decoder.decode(decrypted);
}

// Utility function to decode Base64 to ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}
